export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MS_CLIENT_ID,
    authority: import.meta.env.VITE_MS_TENANT_URL,
    redirectUri: import.meta.env.VITE_MS_REDIRECT,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read', 'Chat.Create', 'Chat.ReadWrite'],
};
